import { createContext, useContext, useState, useEffect } from "react";

// Crea il Context
const ScreenSizeContext = createContext();

// Provider per gestire lo stato globale dello schermo
export const ScreenSizeProvider = ({ children }) => {
    const [isPC, setIsPC] = useState(window.innerWidth > 991); // Definisci la condizione per PC

    useEffect(() => {
        const handleResize = () => {
            setIsPC(window.innerWidth > 991);
        };

        window.addEventListener("resize", handleResize);
        handleResize(); // Imposta lo stato iniziale

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <ScreenSizeContext.Provider value={isPC}>
            {children}
        </ScreenSizeContext.Provider>
    );
}

// Hook personalizzato per usare il valore in altri componenti
export const useScreenSize = () => {
    return useContext(ScreenSizeContext);
}
